module.exports = require('./multiply')
